import React from 'react';
import { useIntl } from 'react-intl';
import { camelCase } from 'lodash/fp';
import { IInsured } from '@whitelabel/helpers/types';
import { IAttributes } from '../../../helpers/types';
import { getInsuredLabel, getInsuredItems } from '../../../helpers/bookings';
import {
  StyledPDSInsuredCard,
  StyledCardBody,
  StyledTitle,
  StyledList,
  StyledListItem,
  StyledInsuredAttributes,
} from './styledPDSInsuredCard';

interface IPDSInsuredCardProps {
  policyType: any; // TODO: PropTypes.oneOf(POLICY_TYPES)
  insured?: IInsured[];
  confirmedAt?: string;
  attributesArray?: IAttributes[];
  partnerTransactionId?: string;
  partnerId: string;
}

const PDSInsuredCard = ({
  policyType,
  insured = [],
  confirmedAt,
  attributesArray = [],
  partnerTransactionId = '',
  partnerId,
}: IPDSInsuredCardProps): JSX.Element => {
  const intl = useIntl();
  const insuredItems = getInsuredItems(policyType, insured, attributesArray, confirmedAt, intl, partnerTransactionId);
  const title = getInsuredLabel(policyType, insured, intl, partnerId, insuredItems.length);
  return (
    <>
      {!!insuredItems.length && (
        <StyledPDSInsuredCard>
          <StyledCardBody>
            <StyledTitle>{title}</StyledTitle>
            <StyledList>
              {insuredItems.map(({ name, attributes }: any) => (
                <StyledListItem key={camelCase(name)}>
                  {name}

                  {!!attributes.length && (
                    <>
                      {' '}
                      <StyledInsuredAttributes>{`(${attributes.join(', ')})`}</StyledInsuredAttributes>
                    </>
                  )}
                </StyledListItem>
              ))}
            </StyledList>
          </StyledCardBody>
        </StyledPDSInsuredCard>
      )}
    </>
  );
};

export default PDSInsuredCard;
